<template>
    <div style="height: 100%; background-color: #FFFFFF;">
      <div class="image-container" v-if="this.hasChart === false">
            <img class="image-box" src="@/assets/ilustracao_erro.svg" alt="">
            <div class="title-image">Nenhum gráfico encontrado</div>
            <div style="font: normal normal normal 16px/33px Segoe UI">Verifique os parâmetros ao lado e click em buscar para exibir os resultados</div>
        </div>
        <div class="mt-2" v-else>
          <div class="header-patologia">
            <div class="title-Chart">
              Quantidade de Patologia
            </div>
            <div class="buton_download">
              <button class="buttonDow" @click="openpopPdf()"><i class="fas fa-download" style="color: #ffffff;"></i></button>
            </div>
          </div>
          <div ref="chartContainer" class="chart-container">
          <!-- <canvas id="myChart"></canvas> -->
              <div id="legends"></div>
            </div>
        </div>

        <b-modal
            hide-footer
            centered
            size="xl"
            ref="popup-pdf-modal"
            id="history-lote">
            <template #modal-header>
                <div class="d-flex justify-content-between align-items-center align-content-center w-100" style="color:#fff">
                    <p id="title-modal">RELATÓRIO DE MANUTENÇÃO EM EDIFICAÇÕES</p>
                    <div class="d-flex">
                        <i class="fa fa-download d-flex mr-4 justify-content-between align-items-center align-content-center"
                            style="color: #fff; cursor: pointer;"
                             @click="generatePDF"
                            v-b-tooltip.hover.bottom title="Download"></i>
                        <div @click="closeModal" class="w-100" id="closed-modal"><i class="fa fa-times" style="cursor: pointer;" v-b-tooltip.hover.bottom title="Fechar"></i></div>
                    </div>
                </div>
            </template>
            <div class="container_pdf">
                <section slot="pdf-content">
                      <img class="cabecalho" src="/static/img/realestate/relatorio/Header_horizontal.png"/>
                      <!-- <img src="/static/img/logotipo/menu/Z-INCORPORAÇÕES7.png" class="size-logo-inco-pdf"/> -->
                </section>
                <div class="title-reports">
                  Relatório de Manutenção em Edificações {{ dataRelatorio }}
                </div>
                <div class="report-filter">
                <div class="filtro_parametros-peq">
                    <div class="filter-text">
                      <div class="border-filter">
                        <i class="fas fa-filter icon-filter d- mr-2 ml-2"></i>
                      </div>
                      <div class="header_filtro">Filtros Utilizados</div>
                    </div>
                    <div class="container_header_filtro">
                      <div class="status_filtro">
                        Status do Chamado:  <strong class="filtrostatus">{{this.StatusFiltro == 'N/D' ? 'TODOS' : this.StatusFiltro}}</strong>
                      </div>
                      <div class="periodo_filtro">
                         Período:  <strong  class="filtrostatus">{{this.periodoFiltro}}  ({{ this.dataInicio }} - {{ this.dataFim }})</strong>
                      </div>
                    </div>

                    <!-- <div class="container-filtro-pato-empre">
                      <div class="empreendimento" >
                        <div><strong>Empreendimentos:</strong></div>
                        <div v-for="(data, index) in empreedimentoArray" v-bind:key="index">{{TotalEmpreendimento === 1 ? data.nomeEmpreendimento : (data.nomeEmpreendimento + (index === empreedimentoArray.length - 1 ? '.' : ', '))}}</div>
                      </div>
                      <div class="patologia">
                        <div><strong>Patologias:</strong></div>
                        <div  v-for="(data, index) in patologiaPdfArray" v-bind:key="index">{{Totalocorrencias === 1 ? data.patologia + ':' + ' Total ' +  data.quantidadeOcorrencia : (data.patologia + ':' + ' Total ' +  data.quantidadeOcorrencia + (index === patologiaPdfArray.length - 1 ? '.' : ', '))}}</div>
                      </div>
                    </div> -->
                </div>
                <div class="qtapatologias">
                  <div class="numeroPatologia">
                    {{quantidadeOcorrenciaReal}}
                  </div>
                  <div class="text-filter">
                    Total de Ocorrências
                  </div>
                  <div class="text-filter-small">
                    *Todos Empreendimentos
                  </div>
                </div>
                <div class="qtapatologias">
                  <div class="numeroPatologia">
                    {{quantidadeOcorrencia}}
                  </div>
                  <div class="text-filter">
                    Total de Patologias
                  </div>
                  <div class="text-filter-small">
                    *Todos Empreendimentos
                  </div>
                </div>
              </div>

                <div v-for="data in GetPdf" :key="data.id" class="container_pdffiltro">
                  <div class="enterprise-report">
                    <div class="enterprise-report-name flex-grow-1">{{ data.nomeEmpreendimento }}</div>
                    <div class="enterprise-report-total mx-2">Total de Ocorrências<strong class="ml-2 enterprise-report-totalnumber">{{data.ocorrenciaByEmpreendimento.length}}</strong></div>
                    <div class="enterprise-report-total">Total de Patologia<strong class="ml-2 enterprise-report-totalnumber">{{data.qtaOcorrencias}}</strong></div>
                  </div>

                  <div class="container_ocorrencias_filtradas">
                    <div class="numero_oce font">Código</div>
                    <div class="empreendimento_oce font">Unidade</div>
                    <div class="tecnico_oce font">Solicitante</div>
                    <div class="descricao_oce font">Descrição</div>
                    <div class="causa_raiza font">Patologia</div>
                    <div class="causa_raiza font">Dt. do Chamado</div>
                    <div class="causa_raiza font">Dt. avaliação Técnica</div>
                    <div class="causa_raiza font">Dt. Prevista Término</div>
                    <div class="causa_raiza font">Dt. Término</div>
                    <div class="situacao font">Engenheiro</div>
                  </div>

                  <div class="container_ocorrencias" v-for=" obj in data.ocorrenciaByEmpreendimento" :key="obj.id">

                    <div class="numero_oce_result font_result">{{obj.testeCodigo}}</div>
                    <div class="empreendimento_oce_result font_result">{{ obj.nomeUnidade }}</div>
                    <div class="empreendimento_oce_result font_result">{{ obj.nomeMorador !== '' ? obj.nomeMorador : '-' }}</div>
                    <div class="descricao_oce_result font_result">{{obj.descricao !== '' ? obj.descricao.length > 300 ? obj.descricao.substring(0, 300) + '[...]' : obj.descricao : '-' }}</div>
                    <div class="patologia_oce_result font_result" v-if="obj.patologiasOcorrencia && obj.patologiasOcorrencia.length > 0">
                      <div v-for="(pat, idx) in obj.patologiasOcorrencia" class="patologia-item-modal" :key="idx">
                        {{ pat.text.length > 300 ? pat.text.substring(0, 300) + '[...]' : pat.text }}
                      </div>
                    </div>
                    <div class="descricao_oce_result font_result" v-else>
                      -
                    </div>
                    <div class="causa_raiza_result font_result">{{obj.dataChamado !== null ? obj.dataChamado : '-'}}</div>
                    <div class="causa_raiza_result font_result">{{obj.dataPrevista !== null ? obj.dataPrevista : '-'}}</div>
                    <div class="causa_raiza_result font_result">{{obj.dataPrevista !== null ? obj.dataPrevista : '-'}}</div>
                    <div class="causa_raiza_result font_result">{{obj.dataTermino !== null ? obj.dataTermino : '-'}}</div>
                    <div class="responsavel_oce-result">
                      <div style="display: flex">
                        <!-- <div class="responsavel_oce_result_desc" style="width: 100%">
                        <div class="tecnico_oce_result font_result"><strong class="filtrostatus mr-3">TEC </strong></div>
                        <div class="engenheiro_oce_result font_result"><strong class="filtrostatus mr-3">ENG </strong></div>
                      </div> -->
                      <div class="responsavel_oce-result" style="width: 100%; padding-left: 10px;">
                        <div class="engenheiro_oce_result font_result">{{ obj.nomeEngenheiro !== null ? '' + obj.nomeEngenheiro : '-'}}</div>
                      </div>
                      </div>
                    </div>
                    <hr>
                  </div>
                </div>
                <hr>
                <div v-if="this.imagem != null" class="img_grafico">
                  <div class="title-Chart_modal">
                    Quantidade de Patologias
                  </div>
                  <img class="img-modal-details" :src="this.imagem.src">
                </div>
                <div class="rodape">
                 Zopone - Relatório de Manutenção em Edificações {{ dataRelatorio }}
                </div>
            </div>
        </b-modal>

       <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename= "Relatorio de Manutenção e Edificação"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :margin="1100"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      @beforeDownload="abrirNovaGuia"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="conteiner_pdf_grafico">
          <div class="pdf-header">
            <div class="nome_relatorio-pdf">
             RELATÓRIO DE MANUTENÇÃO EM EDIFICAÇÕES {{ ' ' + dataFormatada}}
            </div>
          </div>

            <div class="filtro_parametros-pdf">
              <div class="report-filter">
                <div class="filtro_parametros-peq">
                    <div class="filter-text">
                      <div class="border-filter">
                        <i class="fas fa-filter icon-filter d- mr-2 ml-2"></i>
                      </div>
                      <div class="header_filtro">Filtros Utilizados</div>
                    </div>
                    <div class="container_header_filtro">
                      <div class="status_filtro">
                        Status do Chamado:  <strong class="filtrostatus">{{this.StatusFiltro == 'N/D' ? 'TODOS' : this.StatusFiltro}}</strong>
                      </div>
                      <div class="periodo_filtro">
                         Período:  <strong  class="filtrostatus">{{this.periodoFiltro}} ({{ this.dataInicio }} - {{ this.dataFim }})</strong>
                      </div>
                    </div>
                </div>
                <div class="qtapatologias-pdf">
                  <div class="numeroPatologia">
                    {{quantidadeOcorrenciaReal}}
                  </div>
                  <div class="text-filter">
                    Total de Ocorrências
                  </div>
                  <div class="text-filter-small">
                    *Todos Empreendimentos
                  </div>
                </div>
                <div class="qtapatologias-pdf">
                  <div class="numeroPatologia">
                    {{quantidadeOcorrencia}}
                  </div>
                  <div class="text-filter">
                    Total de Patologias
                  </div>
                  <div class="text-filter-small">
                    *Todos Empreendimentos
                  </div>
                </div>
              </div>

              <div v-for="data in GetPdf" :key="data.id" class="container_pdffiltro">
                  <div class="enterprise-report">
                    <div class="enterprise-report-name flex-grow-1">{{ data.nomeEmpreendimento }}</div>
                    <div class="enterprise-report-total mx-2">Total de Ocorrências<strong class="ml-2 enterprise-report-totalnumber">{{data.ocorrenciaByEmpreendimento.length}}</strong></div>
                    <div class="enterprise-report-total">Total de Patologia<strong class="ml-2 enterprise-report-totalnumber">{{data.qtaOcorrencias}}</strong></div>
                  </div>
                  <div class="container_ocorrencias_filtradas">
                    <div class="numero_oce font">Código</div>
                    <div class="empreendimento_oce font">Unidade</div>
                    <div class="tecnico_oce font">Solicitante</div>
                    <div class="descricao_oce font">Descrição</div>
                    <div class="descricao_oce font">Patologia</div>
                    <div class="causa_raiza font">Dt. do Chamado</div>
                    <div class="causa_raiza font">Dt. Avaliação Técnica</div>
                    <div class="causa_raiza font">Dt. Prevista Término</div>
                    <div class="causa_raiza font">Dt. Término</div>
                    <div class="situacao font">Engenheiro</div>
                  </div>
                  <div class="container_ocorrencias" v-for=" obj in data.ocorrenciaByEmpreendimento" :key="obj.id">
                    <div class="numero_oce_result font_result">{{obj.testeCodigo}}</div>
                    <div class="empreendimento_oce_result font_result">{{obj.nomeUnidade }}</div>
                    <div class="empreendimento_oce_result font_result">{{ obj.nomeMorador !== '' ? obj.nomeMorador : '-' }}</div>
                    <div class="descricao_oce_result font_result">{{obj.descricao !== '' ? obj.descricao.length > 150 ? obj.descricao.substring(0, 150) + '...' : obj.descricao : '-' }}</div>
                    <div class="patologia_oce_result font_result" v-if="obj.patologiasOcorrencia && obj.patologiasOcorrencia.length > 0">
                      <div v-for="(pat, idx) in obj.patologiasOcorrencia" :key="idx" class="patologia-item">
                        {{ pat.text.length > 300 ? pat.text.substring(0, 300) + '[...]' : pat.text }}
                      </div>
                    </div>
                    <div class="descricao_oce_result font_result" v-else>
                      -
                    </div>
                    <div class="causa_raiza_result font_result">{{obj.dataChamado !== null ? obj.dataChamado : '-'}}</div>
                    <div class="causa_raiza_result font_result">{{obj.dataChamado !== null ? obj.dataChamado : '-'}}</div>
                    <div class="causa_raiza_result font_result">{{obj.dataPrevista !== null ? obj.dataPrevista : '-'}}</div>
                    <div class="causa_raiza_result font_result">{{obj.dataTermino !== null ? obj.dataTermino : '-'}}</div>
                    <div class="responsavel_oce-result" style="padding-left: 1rem;">
                      <div style="display: flex">
                        <!-- <div class="responsavel_oce_result_desc" style="width: 100%; padding-left: 0.5rem; padding-right: 0.5rem;">
                        <div class="tecnico_oce_result font_result"><strong class="filtrostatus mr-3">TEC </strong></div>
                        <div class="engenheiro_oce_result font_result"><strong class="filtrostatus mr-3">ENG </strong></div>
                      </div> -->
                      <div class="responsavel_oce-result" style="width: 100%">
                        <!-- <div class="tecnico_oce_result font_result">{{ obj.nomeTecnico !== null ? '' + obj.nomeTecnico : '-'}}</div> -->
                        <div class="engenheiro_oce_result font_result">{{ obj.nomeEngenheiro !== null ? '' + obj.nomeEngenheiro : '-'}}</div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
          </div>
          <div class="html2pdf__page-break"></div>
          <div v-if="this.imagem != null" class="img_grafico-pdf conteiner_pdf_grafico " style="display:flex; flex-direction: column; justify-content:center; align-items: center; align-content: center;">
            <div class="title-Chart_modal-pdf">
              Gráfico Quantidade de Patologias
            </div>
            <img class="img-modal-details-pdf" style="height: 510px;" :src="this.imagem.src">
          </div>
    </section>
    </vue-html2pdf>
    </div>
</template>

<script>
import ChartReports from './chartReports.js'
export default ChartReports
</script>

<style scoped>
  .container_pdf section {
    display: flex;
    justify-content: center;
    align-items: center;
  }
    #legends {
      width: 100%;
      height: 100%;
    }
    div #legenda-grafico{
      display: flex;
      flex-wrap: wrap;
      width: 25%;
    }
    .enterprise-report,
    .container_ocorrencias_filtradas,
    .container_ocorrencias,
    .numero_oce_result,
    .empreendimento_oce_resul,
    .causa_raiza_result,
    .responsavel_oce_result_desc,
    .responsavel_oce-result,
    .descricao_oce_result{
      break-inside: avoid;
    }
    .container-filtro{
      break-inside: avoid;
    }
    .cabecalho-pdf{
      width: 500px;
      margin-bottom: 2rem;
    }
    .cabecalho{
      width: 100%;
      margin-bottom: 2rem;
    }
    .rodape {
      width: 100%;
      background: #1C6228;
      color: #FFF;
      font-family: 'Poppins';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px; /* 150% */
      padding-left: 2rem;
      margin-top: 2rem;
    }

    .report-filter{
      display: flex;
      gap: 1rem;
    }
    .title-reports{
      color: #1A1818;
      font-family: 'Poppins';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px; /* 150% */
    }

    .filter-used{
      color: #2E973D;
    }

    .icon-filter{
      color:#2E973D;
    }
    .filter-text{
      display:flex;
      align-items: center;
      padding: 1rem 0 0 1rem;
    }
    .border-filter{
      border-radius: 5px;
      background: #E8E8E8;
      width: 23px;
      height: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right:1rem;
    }
    .qtapatologias{
      width: 215px;
      border-radius: 10px;
      background: #F4F4F4;
      padding: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .qtapatologias-pdf{
      width: 215px;
      border-radius: 10px;
      background: #F4F4F4;
      padding: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .filtrostatus{
      color: #1A1818;
      font-size: 14px;
      font-style: normal;
      font-weight: 800;
      line-height: 27px; /* 225% */
    }
    .numeroPatologia{
      color: #008148;
      text-align: center;
      font-family: 'Poppins';
      font-size: 26px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px; /* 103.846% */
    }
    .text-filter{
      color: #1A1818;
      text-align: center;
      font-family: 'Poppins';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 225% */
    }
    .text-filter-small{
      color: #1A1818;
      text-align: center;
      font-family: 'Poppins';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 337.5% */
    }
    .enterprise-report{
      padding: 0.5rem 1rem 0.5rem 0.5rem;
      border-radius: 10px 10px 0px 0px;
      background: #F4F4F4;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .enterprise-report-name{
      color: #1A1818;
      font-family: 'Poppins';
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px;
    }
    .enterprise-report-total{
      color: #1A1818;
      text-align: center;
      font-family: 'Poppins';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 225% */
    }
    .enterprise-report-totalnumber{
      color: #008148;
      text-align: center;
      font-family: 'Poppins';
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px;
    }
    .image-container{
        display: flex;
        height: 100%;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
      .nome_relatorio {
        display: flex;
        width: 100%;
        justify-content: end;
        font-size: 16px;
        font-weight: bold;
        color: rgb(54, 54, 54);
        font-family:'Poppins';
      }
      .nome_relatorio-pdf {
        display: flex;
        width: 100%;
        /* justify-content: end; */
        font-size: 20px;
        font-weight: bold;
        color: rgb(54, 54, 54);
        font-family:'Poppins';
        margin-bottom: 1rem;
        background: transparent;
      }
      .container-filtro-pato-empre-pdf {
        padding: 1rem;
        display: grid;
        border: solid 1px;
        grid-auto-columns: 1fr;
        grid-auto-rows: 1fr;
        grid-template-columns: 1fr 1fr;
        gap: 0px 0px;
      }
      .container-filtro-pato-empre {
        padding: 10px;
        display: grid;
        border: solid 1px;
        grid-auto-columns: 1fr;
        grid-auto-rows: 1fr;
        grid-template-columns: 1fr 1fr;
        gap: 0px 0px;
      }
    .empreendimento {
      width: 100%;
      text-align: center;
      height: fit-content;
      }
    .patologia {     text-align: center;}
    .concluido{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: #008148;
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }

    .cancelado{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: #960505;
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }
    .vistoria{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: #565656;
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 9px;
    }
    .andamento{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: rgb(13, 39, 184);
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }
    .container_pdf {
      height: 60vh;
      overflow: auto;
      width: 100%;
      border-radius: 5px;
      border-bottom: 1px solid #D4D4D4;
    }
    .container_pdf::-webkit-scrollbar-track {
      background-color: #F4F4F4;
      border-radius: 5px;
    }
    .container_pdf::-webkit-scrollbar {
      padding: 1rem;
        width: 6px;
        border-radius: 5px;
        background: #F4F4F4;
      }
      .container_pdf::-webkit-scrollbar-thumb {
        background: #dad7d7;
        border-radius: 5px;
    }
    .img-modal-details {
      margin-top: 0.5rem;
      margin-left: 20%;
      width: 60%;
    }
    .img_grafico{
      margin: 1rem 0 2rem 0;
    }
    .conteiner_pdf_grafico{
      padding: 1rem;
    }
    .header_filtro{
      color: #1A1818;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 27px; /* 192.857% */
      font-family: 'Poppins';
    }
    .status_filtro {
      color: #1A1818;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 225% */
      width: 45%;
      font-family: 'Poppins';
    }
    .periodo_filtro {
      width: 55%;
      font-family: 'Poppins';
    }
    .empreendimentoPatolofia_filtro{
      width: 100%;
      font-family: 'Poppins';
    }
    .container_header_filtro{
      display: flex;
      padding: 1rem;
      flex-direction: column;
    }
    .filtro_parametros{
      margin-top: 14px;
      width: 100%;
      height: fit-content;
      border-radius: 10px;
      background: #F4F4F4;
      padding: 0.5rem
    }
    .filtro_parametros-peq{
      width: 100%;
      height: fit-content;
      border-radius: 10px;
      background: #F4F4F4;
      padding: 0.5rem
    }

    .filtro_parametros-pdf{
      width: 100%;
      padding: 0.5rem;
      height: fit-content;
      border-radius: 5px;
    }
    .container_pdffiltro{
      margin-top: 2rem;
      width: 100%;
      border-radius: 10px;
      border: 1px solid #F4F4F4;
      break-after: avoid;
      break-inside: avoid;
    }
    .container_pdffiltro-pdf{
      margin-top: 2rem;
      width: 100%;
    }
    .container_ocorrencias_filtradas {
      width: 100%;
      height: 3rem;
      text-align: center;
      border-radius: 5px 5px 0 0;
      background: #2E973D;
      display: flex;
      justify-content: space-around;
      break-after: avoid;
    }
    .container_ocorrencias_filtradas > div {
      width: calc(33.33% - 10px); /* Adjust the width according to your preference */
      margin: 5px; /* Add margin between the div elements */
    }
    .container_ocorrencias_filtradas > .numero_oce, .numero_oce_result   {
      width: 15% !important; /* Adjust the width according to your preference */
      margin: 5px; /* Add margin between the div elements */
    }
    .container_ocorrencias_filtradas > .causa_raiza_result, .causa_raiza   {
      width: 40% !important; /* Adjust the width according to your preference */
      margin: 5px; /* Add margin between the div elements */
    }
    .container_ocorrencias_filtradas >
    .descricao_oce_result,
    .patologia_oce_result
    .descricao_oce {
      width: 50% !important; /* Adjust the width according to your preference */
      margin: 5px; /* Add margin between the div elements */
    }
    .numero_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .empreendimento_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tecnico_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .engenheiro_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .descricao_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .causa_raiza {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .situacao {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .patologia-item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 0;
        border-bottom: 1px solid #ccc;
      }

      .patologia-item-modal {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 0;
      }

      .patologia-item:last-child {
        border-bottom: none; /* remove a linha da última */
      }
    .font{
        color: #FFF;
        font-family: 'Poppins';
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .font_result{
        color: #1A1818;
        font-family:'Poppins';
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }

    .font_result_total{
        padding-right: 1rem;
        font-size:  12px;
        font-weight: bold;
        color: rgb(114, 114, 114);
        font-family:'Poppins';
        margin: 0;
    }
    .container_ocorrencias {
      width: 100%;
      display: flex;
      justify-content: space-around;
      border: #f4f4f4 1px solid
    }
    .container_ocorrencias > div {
      width: calc(33.33% - 10px);
      margin: 5px;
    }

    .container_ocorrencias > .numero_oce,
    .numero_oce_result {
      width: 15% !important;
      margin: 5px;
    }
    .container_ocorrencias > .descricao_oce,
    .descricao_oce_result
    .patologia_oce_result {
      width: 50% !important;
      margin: 5px;
    }
    .container_ocorrencias > .causa_raiza_result,
    .causa_raiza {
      width: 40% !important;
      margin: 5px;
    }
    .responsavel_oce_result_desc {
      width: 5% !important;
    }

    .numero_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .descricao_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .empreendimento_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tecnico_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .engenheiro_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .responsavel_oce_result_desc,
    .responsavel_oce-result{
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .causa_raiza_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .situacao_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .container_ocorrencias_folder {
      width: 100%;
      height: 2rem;
      display: grid;
      grid-auto-columns: 1fr;
      grid-auto-rows: 1fr;
      grid-template-columns: 1fr;
      gap: 0px 0px;
    }

    .totalizados_result {
      display: flex;
      justify-content: end;
      align-items: center;
    }

    #title-modal{
        font-size: 18px;
        font-weight: bold;
        color: white;
        font-family:'Segoe UI';
        margin: 0;
    }
    .pdf-header{
        margin-bottom: 0.5rem;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
    }
    .size-logo-inco-pdf{
      width: 500px;
    }
    .buttonDow{
      height: 30px;
      width: 2.5rem;
      border-radius: 5px;
      border: transparent;
      background: #008148;
    }
    .buton_download{
      margin-top: 0.3rem;
      display: flex;
      justify-content: end;
      padding-right: 1rem;
    }
    .header-patologia{
      display: flex;
      justify-content: center;
      padding: 1rem;
      align-items: center;
    }
    .title-image{
        display: flex;
        justify-content: center;
        font: normal normal normal 28px/33px Segoe UI;
        letter-spacing: -1.51px;
        color: #008148;
    }

    .text-image{
        font: normal normal normal 16px/33px Segoe UI;
        letter-spacing: -0.3px;
        color: #4F4C4D;
    }

    .chart-container {
      width: 100%;
      padding: 0 2rem;
      display: flex;
      flex-direction: column-reverse;
    }

    .title-Chart{
      font: normal normal 600 26px/35px Segoe UI;
      color: #5E5E5E;
      display: flex;
      width: 85%;
      justify-content: center;
    }

    .title-Chart-pdf{
      font: normal normal 600 26px/35px Segoe UI;
      color: #5E5E5E;
      display: flex;
      width: 80%;
      justify-content: center;
    }

    .title-Chart_modal{
      font: normal normal 600 26px/35px Segoe UI;
      color: #5E5E5E;
      display: flex;
      width: 100%;
      justify-content: center;
      margin-bottom: 2rem;
    }

    .title-Chart_modal-pdf{
      font: normal normal 600 26px/35px Segoe UI;
      color: #5E5E5E;
      display: flex;
      width: 100%;
      justify-content: center;
      padding: 0 0 1rem 0;
    }

    #myChart{
      width: 100%;
      height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/reports/components/chartReports/chartReports.vue